import { FC } from 'react';

interface Props {
  value: number;
}
export const ProgressBar: FC<Props> = ({ value }) => {
  return (
    <div className="w-full h-2 bg-gray-200 rounded-xl overflow-hidden">
      <div className="bg-primary-900  h-full" style={{ width: `${value}%` }}></div>
    </div>
  );
};
